// extracted by mini-css-extract-plugin
module.exports = {"container":"RoomOption_container__yqnRS","iconContainer":"RoomOption_iconContainer__3Selc","defaultLogo":"RoomOption_defaultLogo__2gOqN","name":"RoomOption_name__1ZRpY"};